import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/users", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createUser(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("/users", payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/${id}/edit`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    changeUserStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/users/${id}/status`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    sendUserCredentials(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/${id}/send-credentials`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateUser(ctx, { id, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/users/${id}`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
